import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import PropTypes from 'prop-types'
import { has, isUndefined, get, without } from 'lodash';
import withUserSession from './withUserSession'
import { FirebaseProvider } from '../components/firebase/FirebaseProvider'

const withAuthentication = (WrappedComponent) => {
    class AuthenticationLayer extends React.Component {
        state = {}

        render () {
            const { session } = this.props;
            const isLoggedIn = has(session, 'email') && !isUndefined(get(session, 'email'));
            const publicPages = ['/', '/login', '/forgot-password', '/update-password', '/change-password', '/confirm-signup', '/search', '/marketplace'];
            const currentPath = window.location.pathname;

            // Verificar si la ruta actual es pública o comienza con una ruta pública
            const isPublicPage = publicPages.some(publicPage => 
                currentPath === publicPage || currentPath.startsWith(publicPage + '/')
            );

            if (!isLoggedIn && !isPublicPage) {
                window.location.href = '/';
                return '';
            }

            if (isLoggedIn && without(publicPages, '/search', '/marketplace').indexOf(currentPath) !== -1) {
                window.location.href = '/orders-monitor';
                return '';
            }

            return (
                <FirebaseProvider>
                    <WrappedComponent {...this.props} userInfo={session} />
                </FirebaseProvider>
            );
        }
    }

    AuthenticationLayer.propTypes = {
        session: PropTypes.object
    }

    return hoistNonReactStatics(withUserSession(AuthenticationLayer), WrappedComponent)
}

export default withAuthentication;
